const getZzimUrl = dibsType => {
  const htGetInfo = TMON.oApp.oApi.getApiInfo('getDibsInfo', { dibsType });
  const htPostInfo = TMON.oApp.oApi.getApiInfo('postDibsInfo', { dibsType });
  const sLoginUrl = [
    TMON.htLocal.htURL.loginPage,
    encodeURIComponent(window.location.href),
  ].join('');
  const sGetUrl = `${htGetInfo.callParam.url}?${$.param(
    htGetInfo.callParam.params
  )}`;
  const sPostUrl = `${htPostInfo.callParam.url}?${$.param(
    htPostInfo.callParam.params
  )}`;

  return {
    htPostInfo,
    sLoginUrl,
    sGetUrl,
    sPostUrl,
  };
};

export default class Zzim {
  constructor() {
    this.initDealZzim();

    // 앱인 경우 5.3.7 버전 이상부터 판매자찜하기 제공
    /* eslint-disable no-underscore-dangle */
    if (
      TMON.view_mode === 'app' &&
      (TMON.app.checkVersion('5.3.7') === null ||
        TMON.app.checkVersion('5.3.7') < 0)
    ) {
      return;
    }

    this.initPartnerZzim();
  }

  initDealZzim() {
    const {
      htPostInfo: htDealPostInfo,
      sLoginUrl,
      sGetUrl: sDealGetUrl,
      sPostUrl: sDealPostUrl,
    } = getZzimUrl('DEAL');
    const mainDealSrl = `main_deal_srl:${TMON.htStaticData.sDealNo}`;
    const dealDimension = mainDealSrl;
    const wishlistUrl = TMON.wishlist
      ? TMON.wishlist
      : 'https://service.tmon.co.kr/interest/wish';

    this.dealZzim = new window.Zzim({
      sSelector: '[data-zzim=deal]',
      sLoginUrl,
      sGetUrl: sDealGetUrl,
      sPostUrl: sDealPostUrl,
      bSync: true,
      bUseDefaultLottie: false,
      htPostData: htDealPostInfo.callParam.data,
      sButtonText: '상품찜',
      getMessageHtml() {
        return `<div class="tooltip like on">
            <div class="tooltip_content">
              <p class="tooltip_title">마이티몬 &gt; 찜목록에 저장되었습니다.</p>
              <a href="${wishlistUrl}" class="tooltip_button" tl:dimension="${dealDimension}" tl:area="GOWISH.D">찜목록 보러가기</a>
            </div>
            <button type="button" class="tooltip_close" aria-label="닫기"></button>
          </div>`;
      },
    });
  }

  initPartnerZzim() {
    const {
      htPostInfo: htPartnerPostInfo,
      sLoginUrl,
      sGetUrl: sPartnerGetUrl,
      sPostUrl: sPartnerPostUrl,
    } = getZzimUrl('PARTNER');
    const mainDealSrl = `main_deal_srl:${TMON.htStaticData.sDealNo}`;
    const partnerSrl = `partner_srl:${TMON.htStaticData.htDealInfo.partnerNo}`;
    const partnerDimension = `${mainDealSrl}__${partnerSrl}`;
    const wishlistUrl = `${
      TMON.wishlist ? TMON.wishlist : 'https://service.tmon.co.kr/interest/wish'
    }/partner`;

    this.partnerZzim = new window.Zzim({
      sSelector: '[data-zzim=partner]',
      sLoginUrl,
      sGetUrl: sPartnerGetUrl,
      sPostUrl: sPartnerPostUrl,
      bSync: false,
      bUseDefaultLottie: false,
      htPostData: htPartnerPostInfo.callParam.data,
      sButtonText: '판매자찜',
      getMessageHtml() {
        return `<div class="tooltip like on">
            <div class="tooltip_content">
              <p class="tooltip_title">마이티몬 &gt; 찜목록에 저장되었습니다.</p>
              <a href="${wishlistUrl}" class="tooltip_button" tl:dimension="${partnerDimension}" tl:area="GOWISH.PN">찜목록 보러가기</a>
            </div>
            <button type="button" class="tooltip_close" aria-label="닫기"></button>
          </div>`;
      },
    });
  }

  clearEvent() {
    this.dealZzim.destroy();
    this.partnerZzim.destroy();
  }
}
